<template>
<div>
    <div class="selectTypeBox">
        <el-radio-group v-model="selectType" @change="onChangeSelectType">
            <el-radio-button label="待审核"></el-radio-button>
            <el-radio-button label="已审核"></el-radio-button>
            <el-radio-button label="审核失败"></el-radio-button>
        </el-radio-group>
    </div>
    <div class="itemList">
        <div class="itemDiv" v-for="item in dataList" :key="item.id">
            <div class="leftDiv">
                <P>{{item.name}}，{{item.phone}}</P>
                <p>
                    {{item.companyName}}，{{item.positionName}},{{item.createTime}}
                </p>
                <p>
                    投递人
                    标记【{{item.jobPublishStatus === 1 ? "未入职" : item.jobPublishStatus === 2 ? "已入职" : item.jobPublishStatus === 3 ? "已面试" : item.jobPublishStatus === 4 ? "已发Offer" : ""}}】
                </p>
                <p>
                    HR{{item.hrNickname}}{{item.hrPhone}}{{item.isContactInformation === 0 ? "没有查看" : "查看了"}}联系方式，{{item.nickname}}标记【{{item.entryPersonStatus === 1 ? "未入职" : item.entryPersonStatus === 2 ? "已入职" : item.entryPersonStatus === 3 ? "已面试" : item.entryPersonStatus === 4 ? "已发Offer" : ""}}】
                </p>
            </div>
            <div class="rightDiv">
                <div>
                    <el-button @click="oplxr(item)">查看投递人联系方式</el-button>
                    <el-button v-if="item.deliverStatus === '2' && item.adminStatus === 1" @click="openPosition1(item.id, item)">标记入职</el-button>
                                        <el-button v-if="item.deliverStatus === '2' && item.adminStatus === 1" @click="offer(item.id, item)">offer</el-button>
                    <el-button v-if="item.deliverStatus === '2' && item.adminStatus === 1" @click="mianshi(item.id, item)">面试</el-button>

                    <el-button @click="openPdf(item.oldFileUrl)">查看该简历</el-button>
                    <el-button v-if="item.deliverStatus === '1'" @click="shResume(item,2)">通过审核</el-button>
                    <el-button v-if="item.deliverStatus === '1'" @click="showShsb(item,3)">审核失败</el-button>
                </div>
            </div>
        </div>
    </div>
    <div class="block">
        <el-pagination @current-change="handleCurrentChange" :current-page="pageNumber" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="pageTotal">
        </el-pagination>
    </div>
    </el-dialog>
    <el-dialog title="入职确认" :visible.sync="dialogVisible" width="30%">
        <div class="demo-input-suffix">
            <p>候选人月薪（元）：</p>
            <el-input placeholder="请输入候选人月薪" type="number" v-model="monthlyPay">
            </el-input>
        </div>
        <div class="demo-input-suffix">
            <p>佣金（元）：</p>
            <el-input readonly placeholder="请输入佣金" type="number" readonly v-model="moneyReward">
            </el-input>
        </div>
        <div class="demo-input-suffix">
            <p>入职日期</p>
            <el-date-picker v-model="entryDate" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
            </el-date-picker>
        </div>
        <div class="demo-input-suffix">
            <p>结算方式</p>
            <el-switch v-model="commissionMethod" active-text="实时结算" inactive-text="保证期过后结算">
            </el-switch>
        </div>
        <div class="demo-input-suffix">
            <p>首付款（元）：</p>
            <el-input readonly placeholder="" type="number" readonly v-model="homeAmount">
            </el-input>
        </div>
        <div class="demo-input-suffix">
            <p>保证金（元）：</p>
            <el-input readonly placeholder="" type="number" readonly v-model="warrantyAmount">
            </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false;openPosition()">确 定</el-button>
        </span>
    </el-dialog>
    <div class='reasShBox' v-if="reasShBox">
        <div>
            <p class="title">
                职位名称
            </p>
            <p class="cont">
                {{
                    jobInfo.positionName
                }}
            </p>
            <p class="title">
                公司&部门
            </p>
            <p class="cont">
                {{
                    jobInfo.companyName
                }}
                {{
                    jobInfo.branch
                }}
            </p>
            <p class="title">
                公司地址
            </p>
            <p class="cont">
                {{
                    jobInfo.provinceName
                }}
                {{
                    jobInfo.cityName
                }}
                {{
                    jobInfo.areaName
                }}
                {{
                    jobInfo.workingAddress
                }}
            </p>
            <p class="title">
                职位类型
            </p>
            <p class="cont">
                {{
                    jobInfo.jobPosition
                }}
            </p>
            <p class="title">
                学历要求
            </p>
            <p class="cont">
                {{
                    jobInfo.minEducation
                }}
            </p>
            <p class="title">
                学历要求
            </p>
            <p class="cont">
                {{
                    jobInfo.minEducation
                }}
            </p>
            <p class="title">
                工作年限
            </p>
            <p class="cont">
                {{
                    jobInfo.workingLifeMin + '~' + jobInfo.workingLifeMax
                }}
            </p>
            <p class="title">
                薪资待遇
            </p>
            <p class="cont">
                {{
                    jobInfo.minYearSalary + '~' + jobInfo.maxYearSalary + 'w' 
                }}
                {{
                    jobInfo.numberSalary + '薪'
                }}
            </p>
            <p class="title">
                其他
            </p>
            <p class="cont">
                {{
                    '招聘人数：' + jobInfo.recruitsNumber + '人' 
                }}
                {{
                    '汇报对象为' + jobInfo.reportObject + ''
                }}
                {{
                    '下属人数有' + jobInfo.subordinates + '人'
                }}
                {{
                    '面试轮次为' + jobInfo.interviewNumber + '轮'
                }}
            </p>
            <p class="title">
                岗位职责
            </p>
            <p class="cont">
                {{
                    jobInfo.postDuties
                }}
            </p>
            <p class="title">
                任职要求
            </p>
            <p class="cont">
                {{
                    jobInfo.postReQuirements
                }}
            </p>
            <p class="title">
                特殊说明备注
            </p>
            <p class="cont">
                {{
                    jobInfo.des
                }}
            </p>

        </div>
        <div>
            <iframe :src="setPdfUrl"></iframe>
        </div>
        <div class='buttonBox'>
            <el-tooltip class="item" effect="dark" content="关闭" placement="top-start">
                <el-button type="warning" icon="el-icon-check" circle @click="closereasShBox"></el-button>
            </el-tooltip>
        </div>
    </div>

    <el-dialog title="投递人信息" :visible.sync="tdrInfoStatus" width="30%" center>
        <img :src="tdrInfo.avatarPath" style="display: block;
    border-radius: 100%;
    margin: 0 auto;
    padding: 15px;
" />
        <p style="text-align: center; padding: 15px">{{tdrInfo.nickname}}</p>
        <p style="text-align: center; padding: 15px">{{tdrInfo.phone === '' ? '该用户暂未绑定手机号码' : tdrInfo.phone}}</p>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="tdrInfoStatus = false">确 定</el-button>
        </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="shsbInfoStatus" width="30%" center>
        <p style="padding:10px 0">是否确认该简历审核失败</p>
        <el-input :rows="10" type="textarea"  placeholder="请输入该简历未通过的原因" v-model="setShsbItem.sbyyInfo">
        </el-input>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="shsbInfoStatus = false">取 消</el-button>
            <el-button type="primary" @click="qrsb">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
export default {
    name: 'changeBefore',
    props: {},
    data() {
        return {
            positionName: '',
            pageSize: 20,
            pageNumber: 1,
            pageTotal: 0,
            dataList: [],
            id: '',
            dialogVisible: false,
            setid: '',
            setItem: {},
            setPdfUrl: '',
            setnum: '',
            selectType: '待审核',
            selectTypeArray: {
                "待审核": 1,
                "已审核": 2,
                "审核失败": 3
            },
            monthlyPay: 0,
            moneyReward: 0,
            entryDate: '',
            commissionMethod: false,
            homeAmount: 0,
            warrantyAmount: 0,
            jobInfo: {

            },
            tdrInfo: {},
            tdrInfoStatus: false,
            reasShBox: false,
            shsbInfoStatus: false,
            setShsbItem: {
                sbyyInfo: ''
            },
        }
    },
    watch: {
        monthlyPay: function () {
            this.moneyReward = (Number(this.monthlyPay) * 12) * this.jobInfo.commissionRate / 100
            let gz = this.jobInfo.payRules.split(':')
            this.homeAmount = this.moneyReward * Number(gz[0]) / 10
            this.warrantyAmount = this.moneyReward * Number(gz[1]) / 10
        },
    },
    created: function () {
        this.id = this.$route.query.id
        this.getJobInfo()
    },
    methods: {
        openPosition1: function (id, item) {
            this.setid = id
            this.setItem = item
            this.dialogVisible = true
        },
                offer: function (id) {

            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/candidate/adminOffer',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: {
                    candidateId: id,
                }
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.$message({
                        message: 'offer标记成功',
                        type: 'success'
                    });
                    that.getPositionLost()
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
                        mianshi: function (id) {
                           let  that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/candidate/adminInterview',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: {
                                       candidateId: id,

                }
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.$message({
                        message: '面试标记成功',
                        type: 'success'
                    });
                    that.getPositionLost()
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        openPosition: function () {
            if (this.monthlyPay === 0 || this.monthlyPay === '0') {
                this.$message({
                    message: '请填写该候选人月薪',
                    type: 'warning'
                });
                return false
            }
            if (this.entryDate === '') {
                this.$message({
                    message: '请选择该候选人入职日期',
                    type: 'warning'
                });
                return false
            }
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/candidate/adminUpdateStatus',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: {
                    candidateId: this.setItem.id,
                    monthlyPay: this.monthlyPay,
                    moneyReward: this.moneyReward,
                    entryDate: this.entryDate,
                    commissionMethod: this.commissionMethod ? 1 : 2,
                    homeAmount: this.homeAmount,
                    warrantyAmount: this.warrantyAmount
                }
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.$message({
                        message: '入职标记成功',
                        type: 'success'
                    });
                    that.getPositionLost()
                }else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        changePostionName: function () {
            this.pageNumber = 1
            this.getPositionLost()
        },
        getPositionLost: function () {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/candidate/getCandidateList',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: {
                    jobId: this.id,
                    pageSize: this.pageSize,
                    pageNumber: this.pageNumber,
                    deliverStatus: this.selectTypeArray[this.selectType]
                }
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    let demo = response.data.content.list
                    that.dataList = demo
                    that.pageTotal = response.data.content.total
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        getJobInfo: function () {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/job/getJob',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: {
                    jobId: this.id
                }
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.jobInfo = response.data.content
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        handleCurrentChange: function (val) {
            this.pageNumber = val
            this.getPositionLost()
        },
        onChangeSelectType(e) {
            this.pageSize = 20
            this.pageNumber = 1
            this.selectType = e
            this.getPositionLost()
        },
        shResume(item, status) {
            let that = this
            let data = {
                candidateId: item.id,
                deliverStatus: status
            }
            if (item.sbyyInfo !== '' && status === 3) {
                data.deliverDesc = item.sbyyInfo
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/candidate/updataDeliverStatus',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: data
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.getPositionLost()
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        openPdf(url) {
            this.setPdfUrl = url
            this.reasShBox = true
        },
        closereasShBox() {
            this.reasShBox = false
        },
        oplxr(item) {
            let userId = item.userId
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/job/getCandidateUser',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: {
                    userId: userId,
                }
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    debugger
                    let userInfo = response.data.content
                    that.tdrInfoStatus = true
                    that.tdrInfo = userInfo
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        showShsb: function (item) {
            this.setShsbItem = item
            this.setShsbItem.sbyyInfo = ''
            this.shsbInfoStatus = true

        },
        qrsb: function () {
            this.shsbInfoStatus = false
            this.shResume(this.setShsbItem,3)
        }
    },
    mounted: function () {
        this.getPositionLost();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.itemList {
    margin-top: 20px;
}

.itemList .itemDiv {
    background-color: #ffffff;
    width: 80%;
    margin: 0 auto 15px auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    box-sizing: border-box;
    padding: 25px;
    border-radius: 8px;
    min-height: 150px;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
}

.itemList .itemDiv .leftDiv {
    width: 70%;
}

.itemList .itemDiv .leftDiv p {
    font-size: 18px;
    color: #757373;
}

.itemList .itemDiv .leftDiv div {
    padding: 30px 0;
}

.itemList .itemDiv .rightDiv {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
}

.itemList .itemDiv .rightDiv p {
    font-size: 32px;
    color: #1AAD19;
    text-align: center;
}

.itemList .itemDiv .rightDiv .active {
    color: red;
}

.itemList .itemDiv .rightDiv div {
    padding: 30px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
}

.block {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
}

.demo-input-suffix>p {
    padding: 10px 0;
}

.reasShBox {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    position: fixed;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
}

.reasShBox>div {
    width: 50vw;
    height: 100vh;
    overflow: hidden;
    overflow-y: scroll;
}

.reasShBox>div>iframe {
    width: 100%;
    height: 100%;
}

.reasShBox>div:nth-child(1) {
    background-color: #ffffff;
    padding: 30px;
    box-sizing: border-box;
}

.reasShBox>div .title {
    padding: 10px 0;
    width: max-content;
    background-color: #cecece;
}

.reasShBox>div .cont {
    padding: 10px;
    white-space: pre-wrap;
    word-wrap: break-word;
    word-break: break-all;
}

.reasShBox .buttonBox {
    width: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
</style>
